// Skeleton loading placeholder
import type * as React from 'react';

import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="skeleton" className={cn('animate-pulse rounded-tile bg-muted', className)} {...props} />;
}

export { Skeleton };
